import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

import type { ReactNode } from 'react';

type ErrorAlertProps = {
  children: ReactNode;
};

export const ErrorAlert = ({ children }: ErrorAlertProps) => (
  <Alert status="error" data-testid="component-error" mb={2} borderRadius="6px">
    <AlertIcon />
    <AlertDescription>{children}</AlertDescription>
  </Alert>
);
